import { Icon, Tooltip } from '@ksyos/design-system';
import type { OrganizationDataError } from '@common/interfaces/api/organizationDataErrorsApi';
import type { IOrganizationGeneralSettings } from '@common/validation/organization';
import { OrganizationKgoStatus } from '@common/enums';
import { AlertWithTitleAndDescription } from '@frontend/components/elements/AlertWithTitleAndDescription';
import { getSelectedLanguage } from '@frontend/translate';

type OrganizationStatusAlertProps = {
    organization: Pick<IOrganizationGeneralSettings, 'kgoStatus' | 'kgoStatusComment'>;
    organizationDataErrors: OrganizationDataError[];
};

export function OrganizationStatusAlert({ organization, organizationDataErrors }: OrganizationStatusAlertProps) {
    const translate = getSelectedLanguage();

    if (!organization?.kgoStatus) {
        return null;
    }

    return (
        <AlertWithTitleAndDescription
            appearance={organization.kgoStatus === OrganizationKgoStatus.verified ? 'success' : 'warning'}
            description={organizationDataErrors
                .map((dataError) => translate.organizationDataErrorType[dataError.type])
                .join(', ')}
            hasIcon={true}
            title={
                <>
                    {translate.common.status}: {translate.organization.kgoStatuses[organization.kgoStatus]}{' '}
                    {organization.kgoStatusComment && (
                        <Tooltip content={organization.kgoStatusComment}>
                            <Icon
                                color="inherit"
                                icon="contact"
                                sx={{ ml: 2 }}
                            />
                        </Tooltip>
                    )}
                </>
            }
        />
    );
}
